// In pages/MSEDCLDashboard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography, Space, Breadcrumb } from "antd";
import {
  FileTextOutlined,
  FilePdfOutlined,
  ExperimentOutlined,
  SafetyOutlined,
  ThunderboltOutlined,
  HomeOutlined
} from "@ant-design/icons";

const { Title, Text } = Typography;

const MSEDCLDashboard = () => {
  const navigate = useNavigate();

  const documentTypes = [
    {
      key: "wcr",
      title: "Work Completion Report",
      subtitle: "WCR",
      icon: <FileTextOutlined />,
      color: "#1890ff",
      path: "/msedcl/wcr"
    },
    {
      key: "proforma",
      title: "Proforma Invoice",
      subtitle: "Billing",
      icon: <FilePdfOutlined />,
      color: "#52c41a",
      path: "/msedcl/proforma"
    },
    {
      key: "declaration",
      title: "Declaration / Undertaking",
      subtitle: "Annexure-A",
      icon: <SafetyOutlined />,
      color: "#fa8c16",
      path: "/msedcl/declaration"
    },
    {
      key: "meterTesting",
      title: "Meter Testing Letter",
      subtitle: "Testing Request",
      icon: <ExperimentOutlined />,
      color: "#722ed1",
      path: "/msedcl/meter-testing"
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      {/* Header Section */}
      <div style={{ marginBottom: '24px' }}>
        <Breadcrumb style={{ marginBottom: '16px' }}>
          <Breadcrumb.Item onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>MSEDCL Documents</Breadcrumb.Item>
        </Breadcrumb>
        <Row justify="space-between" align="middle">
          <Col>
            <Space size="middle">
              <ThunderboltOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
              <Title level={4} style={{ margin: 0 }}>MSEDCL Documents Generation</Title>
            </Space>
          </Col>
        </Row>
      </div>

      {/* Document Grid */}
      <Row gutter={[24, 24]}>
        {documentTypes.map((doc) => (
          <Col xs={24} sm={12} lg={6} key={doc.key}>
            <Card
              hoverable
              onClick={() => navigate(doc.path)}
              style={{
                borderRadius: '12px',
                textAlign: 'center',
                height: '100%',
                border: '1px solid #f0f0f0',
                transition: 'all 0.3s ease'
              }}
              bodyStyle={{ padding: '32px 24px' }}
            >
              <div style={{
                fontSize: '40px',
                color: doc.color,
                marginBottom: '16px',
                height: '64px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {doc.icon}
              </div>
              <Title level={5} style={{ marginBottom: '4px' }}>
                {doc.title}
              </Title>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {doc.subtitle}
              </Text>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default MSEDCLDashboard;
